import React from 'react'
import Header from './Header'
import EcomProjectBody from './EcomProjectBody'
import ProductPageFooter from './ProductPageFooter'

const EcomProject = () => {
  return (
    <>
     <Header/>
     <EcomProjectBody/>
     <ProductPageFooter/>
    </>
  )
}

export default EcomProject